// The add-emission category cards, and whether an emission factor can price each one.
//
// The cards a group offers come from a curated allow-list on the backend. That list says a group and
// category pairing is permitted; it does not say any factor exists for it, so a card could lead to
// an empty factor list. The backend now reports, per category, the factor sources that hold at
// least one activity factor in the group's scope (`conversionSourceIds`).
//
// Only one thing is worth telling the user on a card: that NO factor can price it, so the entry has
// to be a CO2e figure. Which source the factors come from is not: the form picks a source, and
// whether that is the organisation's default is of no interest to someone choosing a category.
// A card is labelled, never hidden, because a CO2e figure can always be entered directly.

export type CategoryFactorAvailability =
  | 'unknown' // a backend that predates the field: behave exactly as before
  | 'available' // at least one factor source can price it
  | 'none'; // no factor in this group's scope: direct CO2e entry only

interface CategoryWithSources {
  conversionSourceIds?: string[] | null;
}

export function getCategoryFactorAvailability(category: CategoryWithSources | undefined | null): CategoryFactorAvailability {
  const sourceIds = category?.conversionSourceIds;
  if (!Array.isArray(sourceIds)) return 'unknown';
  return sourceIds.length === 0 ? 'none' : 'available';
}

/** The chip a category card carries, or undefined for a card that needs no comment. */
export function getCategoryCardChipLabel(availability: CategoryFactorAvailability): string | undefined {
  return availability === 'none' ? 'CO₂e entry only' : undefined;
}
